import React from "react";
import style from "../../index.module.scss";
import { InputNumber } from "antd";
import { InputNumberProps } from "antd/es/input-number";

interface IProps extends InputNumberProps {}

const Index = ({ ...props }: IProps) => {
    return (
        <InputNumber
            {...props}
            min={0}
            max={100}
            className={style.inputNumber}
        />
    );
};

export default Index;
